import { render, staticRenderFns } from "./DataInputAutocomplete.vue?vue&type=template&id=f041d1d8&scoped=true&"
import script from "./DataInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DataInputAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DataInputAutocomplete.vue?vue&type=style&index=0&id=f041d1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041d1d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
